var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"text-center",attrs:{"outlined":"","tile":""}},[_vm._v("\n  m"),_c('sup',[_vm._v("2")]),_vm._v(" x\n  "),_c('Paquete',{staticClass:"ml-1 mr-1"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }